// 附件的预览、下载
import axios from "axios"
import bus from "./bus.js"
import { imgReg } from "@/utils/validate"
import { sysAppId } from '@/settings.js'
import store from '@/store'
import { isValidUrl } from "@/utils/validate"


function checkStatus(response) {
  if (response && response.status === 200) {
    // loading,如果http状态码正常，则直接返回数据
    let _data = response.data;
    if (!_data) {
      bus.$message.error("服务器开了个小差");
      return false;
    } else {
      const uu = "data:" + response.headers['content-type'] + ";base64," + btoa(new Uint8Array(_data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ""
      ))
      return uu
    }
  } else {
    return false;
  }
}

function checkStatus2(response) {
    if (response && response.status === 200) {
      // loading,如果http状态码正常，则直接返回数据
      let _data = response.data;
      if (!_data) {
        bus.$message.error("服务器开了个小差");
        return false;
      } else {
        const uu = "data:" + response.headers['content-type'] + ";base64," + btoa(new Uint8Array(_data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        ))
        return {url:uu,extract:response.headers['validatecodekey']}
      }
    } else {
      return false;
    }
  }

export function getFileRead(fileUrl) {
  let dataUrl = `${isValidUrl(window.g.API_ROOT)}/api/File/ReadFile`;
  let token = store.getters.token
  // var showUrl = '';
  //二进制流转换为base64
  return axios.get(dataUrl, {
    headers:{
        Authorization:'Bearer ' + token,
        sysappid:sysAppId
    },
    params: { fileUrl: fileUrl },
    responseType: "arraybuffer"
  }).then(res => {
    return checkStatus(res)
  }).catch(ex => {
    return ''
  });
}
// export function uploadUserPhoto(fileUrl) {
//   let dataUrl = `${window.g.API_ROOT}/api/File/UploadUserPhoto`;
//   // var showUrl = '';
//   //二进制流转换为base64
//   return axios.post(dataUrl, {
//     params: { fileUrl: fileUrl },
//     responseType: "arraybuffer"
//   }).then(res => {
//     return checkStatus(res)
//   }).catch(ex => {
//     return ''
//   });
// }

export function getFileDownload(fileUrl) {
  let dataUrl = `${isValidUrl(window.g.API_ROOT)}/api/File/DownLoadFile`;
  // var showUrl = '';
  //二进制流转换为base64
  return axios.get(dataUrl, {
    headers:{
        Authorization:'Bearer ' + token,
        sysappid:sysAppId
    },
    params: { fileUrl: fileUrl },
    responseType: "arraybuffer"
  }).then(res => {
    return checkStatus(res)
  }).catch(ex => {
    return ''
    //  console.error(ex)
  });
}

export function getImgUrl() {
    let dataUrl = `${isValidUrl(window.g.API_ROOT)}/api/Jwt/CreateValidateCode`;
    // var showUrl = '';
    //二进制流转换为base64
    return axios.get(dataUrl, {
      responseType: "arraybuffer"
    }).then(res => {
      return checkStatus2(res)
    }).catch(ex => {
      return ''
      //  console.error(ex)
    });
  }

// 预览
export function winOpenFile(fileName, content) {
  if (imgReg(fileName)) {
    // 验证是否为图片
    const img = new Image();
    img.src = content;
    const newWin = window.open("", "_blank");
    newWin.document.write(img.outerHTML);
    newWin.document.title = fileName
    newWin.document.close();
  } else {
    window.open(content, "_blank");
  }
}

//下载
export function downloadFile(fileName, content) {
  var aLink = document.createElement('a');
  var blob = base64ToBlob(content); //new Blob([content]);
  var evt = document.createEvent("HTMLEvents");
  evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
  aLink.download = fileName;
  aLink.href = URL.createObjectURL(blob);
  // aLink.dispatchEvent(evt);
  aLink.click()
}
//base64转blob
function base64ToBlob(code) {
  var parts = code.split(';base64,');
  var contentType = parts[0].split(':')[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;

  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
}
//从响应头获取文件名
function getFilenameFromHeaders(headers) {
  let disposition = headers['content-disposition'] || '';
  let fileName = parseFilenameFromDisposition(disposition);
   // 如果解析失败，使用默认文件名
    if (!fileName) {
        fileName = `download.txt`;
    }
  fileName = fileName
            .replace(/^_+/, '') // 移除开头下划线
            .replace(/;.*$/, '') // 移除分号后的内容
            .replace(/_{2,}/g, '_') // 减少连续下划线
            .replace(/\s+\(\d+\)$/, ''); // 移除末尾的 (数字)

        // 确保文件名以 .txt 结尾
        if (!fileName.endsWith('.txt')) {
            fileName += '.txt';
        }
  return fileName
}

function parseFilenameFromDisposition(disposition) {
    if (!disposition) return null;

    // 1. 优先尝试提取 UTF-8 编码的文件名 (filename*)
    const utf8FilenameMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8FilenameMatch && utf8FilenameMatch[1]) {
        try {
            // 对 URL 编码的文件名进行解码
            return decodeURIComponent(utf8FilenameMatch[1]);
        } catch (e) {
            console.error('UTF-8 文件名解码失败:', e);
            // 继续尝试其他方法
        }
    }

    // 2. 尝试提取标准文件名 (filename)
    const standardFilenameMatch = disposition.match(/filename="([^"]+)"/i);
    if (standardFilenameMatch && standardFilenameMatch[1]) {
        return standardFilenameMatch[1];
    }

    // 3. 尝试提取不带引号的文件名
    const unquotedFilenameMatch = disposition.match(/filename=([^;]+)/i);
    if (unquotedFilenameMatch && unquotedFilenameMatch[1]) {
        return unquotedFilenameMatch[1];
    }

    return null;
}

//导出应用的权限、菜单等数据
export function getDataSql(params){
    let dataUrl = `${isValidUrl(window.g.API_ROOT)}/api/SysApp/GetDataSql`
    let token = store.getters.token
    return axios.get(dataUrl, {
        params,
        responseType: "blob",
        headers:{
            Authorization:'Bearer ' + token,
            sysappid:sysAppId
        }
      }).then(res => {
        return res
      }).catch(err => {
        return ''
      });
}

//导出脚本数据
export function getDataSqlFile(params,name,url){
    let dataUrl = `${isValidUrl(window.g.API_ROOT)}${url}`
    let token = store.getters.token
    return axios.get(dataUrl, {
        params,
        responseType: "arraybuffer",
        headers:{
            Authorization:'Bearer ' + token,
            sysappid:sysAppId
        }
      }).then(res => {
        // let name = getFilenameFromHeaders(res.headers)
       let str = checkStatus(res)
        downloadFile(name,str)
        return res
      }).catch(err => {
        return ''
      });
}


// WEBPACK FOOTER //
// ./src/api/fileapi.js